import { Injectable } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class DatePickerUtilitiesService {
  public readonly endPickerPanelClass = 'single-end-date-picker-with-range';

  public endPickerDateClass(startDate?: Date | null, endDate?: Date | null): MatCalendarCellClassFunction<Date> {
    return (date: Date): string => {
      if (!startDate) {
        return '';
      }

      const normalizedStartDate: Date = startOfDay(startDate);
      const normalizedDate: Date = startOfDay(date);

      if (!endDate) {
        if (isSameDay(normalizedDate, normalizedStartDate)) {
          return 'end-range-start';
        }

        return '';
      }

      const normalizedEndDate: Date = startOfDay(endDate);

      if (isSameDay(normalizedDate, normalizedStartDate) && isSameDay(normalizedDate, normalizedEndDate)) {
        return 'end-range-single';
      }

      if (isSameDay(normalizedDate, normalizedStartDate)) {
        return 'end-range-start';
      }

      if (isSameDay(normalizedDate, normalizedEndDate)) {
        return 'end-range-end';
      }

      if (isAfter(normalizedDate, normalizedStartDate) && isBefore(normalizedDate, normalizedEndDate)) {
        return 'end-range-middle';
      }

      return '';
    };
  }

  public getValidEndDate(endDate: Date | null, startDate: Date | null): Date | null {
    if (!endDate) {
      return null;
    }

    if (!startDate) {
      return endDate;
    }

    if (isBefore(startOfDay(endDate), startOfDay(startDate))) {
      return startDate;
    }

    return endDate;
  }
}
